function getLastType(is_slp, is_rlm){
    if (is_slp === "YES" && is_rlm === "YES") return "SLP & RLM";
    else if (is_slp === "YES") return "SLP";
    else if (is_rlm === "YES") return "RLM";
    else return "N/A"
}
export default getLastType;